import { i18n } from "@/i18n";

export default {
  path: "/error",
  name: "ErrorLayout",
  component: () => import(/* webpackChunkName: "global" */ "@/views/Global/GlobalLayoutView.vue"),
  redirect: { name: "Error" },
  meta: {
    breadcrumb: true,
    title: i18n.global.t("page.error"),
  },
  children: [
    {
      path: "error",
      name: "Error",
      component: () => import(/* webpackChunkName: "error" */ "@/views/Error/ErrorView.vue"),
      meta: {
        title: i18n.global.t("page.error"),
      },
    },
    {
      path: "maintenance",
      name: "Maintenance",
      component: () => import(/* webpackChunkName: "error" */ "@/views/Error/MaintenanceView.vue"),
      meta: {
        title: i18n.global.t("page.maintenance"),
      },
    },
    {
      path: "platform-no-found",
      name: "PlatformNotFound",
      component: () => import(/* webpackChunkName: "error" */ "@/views/Error/PlatformNotFoundView.vue"),
      meta: {
        title: i18n.global.t("page.platformNotFount"),
      },
    },
  ],
};
